import React from "react";
import { NavLink, Route, Switch } from "react-router-dom";
import { Panel } from "@culturehq/components";

import { useProfile } from "app/context";
import { t } from "app/utils";
import JobMappings from "./settings/JobMappings";

interface SettingOptionProps {
  to: string;
  phrase: string;
}

const SettingsJobMappings: React.FC = () => {
  const { profile } = useProfile();
  const { organization } = profile;

  const SettingOption: React.FC<SettingOptionProps> = ({ to, phrase }) => (
    <li role="navigation">
      <NavLink to={to} activeClassName="active">{phrase}</NavLink>
    </li>
  );

  if (!organization.externalMappers || organization.externalMappers.length === 0) {
    return (
      <Panel limitWidth>
        <Panel.Body>
          <p>No job mappings available to display.</p>
        </Panel.Body>
      </Panel>
    );
  }

  const filteredMappers = organization.externalMappers.filter(mapper => mapper.label);
  if (filteredMappers.length === 0) {
    return (
      <Panel limitWidth>
        <Panel.Body>
          <p>No valid job mappings found.</p>
        </Panel.Body>
      </Panel>
    );
  }

  return (
    <Panel limitWidth>
      <ul role="tablist" aria-label={t("Settings options")} className="nav nav-tabs">
        {filteredMappers.map(mapper => (
          <li key={mapper.id} className="nav-item">
            <SettingOption
              to={`/admin/mappings/${mapper.label.toLowerCase().replace(/\s+/g, "-")}`}
              phrase={`${mapper.label}`}
            />
          </li>
        ))}
      </ul>
      <Panel.Body>
        <Switch>
          {filteredMappers.map(mapper => (
            <Route
              key={mapper.id}
              exact
              path={`/admin/mappings/${mapper.label.toLowerCase().replace(/\s+/g, "-")}/:page?`}
              render={() => (
                <JobMappings externalMapper={mapper} />
              )}
            />
          ))}
        </Switch>
      </Panel.Body>
    </Panel>
  );
};

export default SettingsJobMappings;
